import { render, staticRenderFns } from "./CustomerSingleReport.vue?vue&type=template&id=0647aee7&scoped=true&"
import script from "./CustomerSingleReport.vue?vue&type=script&lang=js&"
export * from "./CustomerSingleReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSingleReport.vue?vue&type=style&index=0&id=0647aee7&lang=scss&scoped=true&"
import style1 from "./CustomerSingleReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647aee7",
  null
  
)

export default component.exports